import { cn } from "@sylviq/ui-react-web/lib/cn";
import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

const badgeVariants = cva("inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold", {
  variants: {
    tone: {
      neutral: "bg-[var(--muted)] text-[var(--muted-foreground)]",
      success:
        "bg-[var(--status-success-background,var(--muted))] text-[var(--status-success-foreground,var(--foreground))]",
      warning:
        "bg-[var(--status-warning-background,var(--muted))] text-[var(--status-warning-foreground,var(--foreground))]",
      danger:
        "bg-[var(--status-danger-background,var(--muted))] text-[var(--status-danger-foreground,var(--foreground))]",
    },
  },
  defaultVariants: { tone: "neutral" },
});

export function Badge({
  className,
  tone,
  ...props
}: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
